import React from "react";
import { motion } from "framer-motion";
import { ChevronDown, Users } from "lucide-react";

export default function FestivalHero({ onScrollToForm, loggedIn }) {
  return (
    <section className="relative min-h-screen flex flex-col justify-center items-center px-4 pt-24 pb-16 overflow-hidden" dir="rtl">
      <div className="relative z-10 text-center max-w-2xl mx-auto w-full">

        {/* Badge */}
        <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.1 }}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6 text-sm font-bold"
          style={{ background: "rgba(200,80,255,0.15)", border: "1.5px solid rgba(200,80,255,0.5)", color: "#e080ff" }}>
          <span className="w-2 h-2 rounded-full bg-purple-400 animate-pulse inline-block" />
          הרשמה מוקדמת פתוחה עכשיו
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }}
          className="font-black leading-tight mb-5 text-white"
          style={{ fontSize: "clamp(2.6rem, 7vw, 5rem)", textShadow: "0 0 60px rgba(200,80,255,0.4)" }}>
          זכו בכרטיסים
          <span className="block" style={{
            background: "linear-gradient(90deg, #c850ff, #ff50b4, #ff9050)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text"
          }}>
            לפסטיבל השנה
          </span>
        </motion.h1>

        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.25 }}
          className="text-lg md:text-xl mb-8 max-w-lg mx-auto leading-relaxed font-medium"
          style={{ color: "rgba(255,255,255,0.8)" }}>
          Mom3ntum מעניקה כרטיסים VIP לאירועי המוזיקה הגדולים ביותר —
          <strong className="text-white"> הירשמו עכשיו</strong> ותגדילו את הסיכויים שלכם.
        </motion.p>

        {/* Info pills */}
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}
          className="flex flex-wrap justify-center gap-3 mb-10">
          {[
            { emoji: "🎵", text: "אירועים בינלאומיים" },
            { emoji: "🎟", text: "כרטיסי VIP" },
            { emoji: "🌍", text: "ברחבי העולם" },
          ].map((item, i) => (
            <span key={i} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold"
              style={{ background: "rgba(255,255,255,0.08)", border: "1.5px solid rgba(255,255,255,0.2)", color: "#fff", backdropFilter: "blur(4px)" }}>
              {item.emoji} {item.text}
            </span>
          ))}
        </motion.div>

        {/* Stats */}
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35 }}
          className="flex justify-center gap-8 mb-10">
          {[
            { val: "500+", label: "זוכים כבר השנה" },
            { val: "50+", label: "אירועים בשנה" },
            { val: "12K+", label: "חברי קהילה" },
          ].map((s, i) => (
            <div key={i} className="text-center">
              <div className="font-black text-2xl" style={{ color: "#e080ff" }}>{s.val}</div>
              <div className="text-xs" style={{ color: "rgba(255,255,255,0.5)" }}>{s.label}</div>
            </div>
          ))}
        </motion.div>

        {/* CTA */}
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.4 }}
          className="flex flex-col items-center gap-3">
          <button onClick={onScrollToForm}
            className="inline-flex items-center gap-2 font-black text-xl px-12 py-5 rounded-full transition-all duration-200 active:scale-95 group"
            style={{ background: "linear-gradient(135deg,#c850ff,#ff50b4)", color: "#fff", boxShadow: "0 8px 40px rgba(200,80,255,0.45)" }}>
            {loggedIn ? "רוצה להתחיל לצבור נקודות?" : "אני רוצה כרטיסים!"}
            <ChevronDown className="w-5 h-5 group-hover:translate-y-1 transition-transform" />
          </button>
          <span className="flex items-center gap-1.5 text-sm font-medium" style={{ color: "rgba(255,255,255,0.55)" }}>
            <Users className="w-4 h-4" /> הרשמה חינמית · ללא התחייבות
          </span>
        </motion.div>
      </div>
    </section>
  );
}